import React, { useEffect } from "react"
import { connect } from "react-redux"
import store from "./shared_component/utils/configureStore"
import { setFlutterApp } from "./v1/actions/flutterInit"

const FlutterInit = ({ isLoggedIn }) => {
  useEffect(() => {
    if (isLoggedIn) {
      initFlutter()
    }
  }, [isLoggedIn])

  return <></>
}

const mapStateToProps = (state) => {
  const flutterApp = state.flutterApp
  let user = state.user || {}
  return {
    flutterApp: flutterApp || null,
    isLoggedIn: !!user.authentication_token
  }
}

export default connect(mapStateToProps)(FlutterInit)

export function initFlutter() {
  if (window._flutter && window._flutter.loader) {
    loadFlutter()
  } else {
    document.addEventListener("DOMContentLoaded", (event) => {
      loadFlutter()
    })
  }
}

function loadFlutter() {
  window._flutter.loader.load({
    // serviceWorkerSettings: {
    //   serviceWorkerVersion: null
    // },
    onEntrypointLoaded: async function (engineInitializer) {
      const appRunner = await engineInitializer.initializeEngine({
        multiViewEnabled: true
      })
      let flutterApp = await appRunner.runApp()
      store.dispatch(setFlutterApp(flutterApp))
    }
  })
}
